export default __webpack_public_path__ + "static/media/nflCardBg.359e42f6.png";